// Shared category grid used by both Menu and Catering.
// Handles loading / error / empty states and iterates categories,
// delegating per-item rendering to the caller via renderItem.
export const OfferingGrid = ({
  loading,
  error,
  categories,
  gridClassName,
  categoryClassName,
  renderItem,
  loadingText = "Loading...",
  emptyText = "No items available",
}) => (
  <div className={gridClassName}>
    {loading ? (
      <p className="menu-message">{loadingText}</p>
    ) : error ? (
      <p className="menu-message error">{error}</p>
    ) : Object.keys(categories).length > 0 ? (
      Object.entries(categories).map(([categoryName, items]) => (
        <div key={categoryName} className={categoryClassName}>
          <h3>{categoryName}</h3>
          {items.map(renderItem)}
        </div>
      ))
    ) : (
      <p className="menu-message">{emptyText}</p>
    )}
  </div>
);
